import { ProgramThumbnailGroupItem } from '@type/buzzkuri/program-detail'
import { useMemo, useState } from 'react'

type Props = {
  programThumbnailGroup: ProgramThumbnailGroupItem[]
  perElm: number
}

type UseProgramsSlide = {
  idx: number
  slideAction: () => void
}

export const useProgramsSlide = ({
  programThumbnailGroup,
  perElm,
}: Props): UseProgramsSlide => {
  const [idx, setIdx] = useState(0)

  const slideAction = useMemo(() => {
    return () =>
      setIdx((preState) =>
        programThumbnailGroup.length / perElm - 1 > preState ? preState + 1 : 0
      )
  }, [perElm, programThumbnailGroup.length])

  return { idx, slideAction }
}
